
import React from 'react';
import Svg, { G, Path, Text as SvgText } from 'react-native-svg';

const VerifyGateLogo: React.FC<{ style?: object, color?: string, height?: number }> = ({ style, color = "#1e293b", height = 30 }) => (
    <Svg style={style} height={height} viewBox="0 0 180 30" fill="none">
        <G transform="translate(0, 2)">
            <Path d="M12 0L0 25H8L20 0H12Z" fill={color} opacity="0.6"/>
            <Path d="M20 0L32 25H40L16 0H20Z" fill={color}/>
        </G>
        <SvgText 
            x="48" 
            y="23" 
            fontFamily="System"
            fontSize="24" 
            fontWeight="bold" 
            fill={color}
        >
            VerifyGate
        </SvgText>
    </Svg>
);

export default VerifyGateLogo;
